export const CallSettings = {
  title: '通話設定',
  enableVideoCall: {
    title: 'カメラを有効にする',
    message:
      '"カメラを有効にする"をオンにすると、お薬の説明開始時にカメラが有効になります。お薬の説明開始時にカメラを有効にしたくない場合はオフにしてください。',
  },
  enableSoftWareAEC: {
    title: 'ソフトウェアAECを有効にする',
    message:
      '通話中にエコーが発生する場合、ソフトウェアAECを有効にするとエコーが改善される場合があります。',
  },
  enableSoftWareNS: {
    title: 'ソフトウェアNSを有効にする',
    message:
      '通話中にノイズが発生する場合、ソフトウェアNSを有効にするとノイズが改善される場合があります。',
  },
  applyButton: '設定',
};
